export type MetaPixelPayload = Record<string, unknown>

export function track (event: 'ViewContent' | 'AddToCart' | 'Purchase', data: MetaPixelPayload) {
  window.fbq?.('track', event, data)
}
